import ApiService from './api.service';

export default class AnimationsTypes {
  static async fetchAnimationsTypes(params) {
    const animations = await ApiService.get('/resources/animations', {
      params,
    });

    return animations;
  }

  static async findAnimationType(animationId) {
    return ApiService.get(`/resources/animations/${animationId}`);
  }

  static async deleteAnimationType(animationId) {
    return ApiService.delete(`/resources/aimations/${animationId}`);
  }

  static async createAnimationType(animation) {
    return ApiService.post('/resources/animations', animation);
  }

  static async updateAnimationType(animation) {
    const { id } = animation;
    delete animation.id;

    return ApiService.put(`/resources/animations/${id}`, animation);
  }
}
